import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    const sid = sp.get("session_id");
    if (!sid) { navigate("/"); return; }

    let cancelled = false;
    let count = 0;

    const poll = async () => {
      if (cancelled) return;
      count += 1;
      setAttempts(count);
      if (count > 8) { setStatus("timeout"); return; }
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (r.data.status === "expired") {
          setStatus("failed");
          return;
        }
      } catch (_e) {/* */}
      setTimeout(poll, 2000);
    };

    poll();
    return () => { cancelled = true; };
  }, [sp, navigate]);

  return (
    <div className="max-w-md mx-auto py-20 px-6 text-center">
      {status === "polling" && (
        <>
          <Loader2 className="w-14 h-14 mx-auto text-[#C85A32] animate-spin"/>
          <p className="mt-4 font-heading font-bold text-2xl text-[#1A1A18]">{t("payment_processing")}</p>
          <p className="mt-2 text-sm text-[#7A7A73]">Attempt {attempts}/8</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 mx-auto text-[#2A5C38]"/>
          <p className="mt-4 font-heading font-bold text-2xl text-[#1A1A18]">{t("payment_success")}</p>
          <p className="mt-2 text-sm text-[#4A4A45]">{t("listing_active")}</p>
          <Link to="/profile" className="mt-6 inline-block btn-primary" data-testid="back-to-profile">
            {t("nav_profile")}
          </Link>
        </>
      )}
      {(status === "failed" || status === "timeout") && (
        <>
          <XCircle className="w-14 h-14 mx-auto text-[#C85A32]"/>
          <p className="mt-4 font-heading font-bold text-2xl text-[#1A1A18]">{t("payment_failed")}</p>
          <Link to="/profile" className="mt-6 inline-block btn-secondary">
            {t("nav_profile")}
          </Link>
        </>
      )}
    </div>
  );
}
